import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { DocumentosProjeto } from '../models/documentos-projeto.model';
import { Observable } from 'rxjs';
import { IrcpProjeto } from '../models/ircp-projeto.model';
import { AditivoIrcpIrfe } from '../models/aditivo-ircp-irfe.model';

@Injectable({
  providedIn: 'root',
})
export class IrcpProjetoService extends BaseService<IrcpProjeto> {
  public readonly LABEL_TOOLTIP: string = 'Instrumento de repasse da consulta popular';

  constructor(public http: HttpClient) {
    super(http);
  }

  public listCombos(id: number): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/list-combos/" + id, { headers: this.headers });
  }

  public listPPA(id: number, obj): Observable<any> | any {
    return this.http.post<any>(this.baseUrl + "/list-ppa/" + id, obj, { headers: this.headers });
  }

  public listCitiesForCorede(id: number): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/list-cities-corede/" + id, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/ircp';
  }

  public getPermission(id: number):  Observable<any>{
    return this.http.get<any>(this.baseUrl + "/permission/" + id);
  }

  public getAditivoList(id: number): Observable<AditivoIrcpIrfe[]> {
    return this.http.get<AditivoIrcpIrfe[]>(this.baseUrl + '/aditivo-list/' + id, { headers: this.headers });
  }

  public getAditivoById(aditivo_id: number): Observable<AditivoIrcpIrfe> {
    return this.http.get<AditivoIrcpIrfe>(this.baseUrl + '/aditivo/' + aditivo_id, { headers: this.headers });
  }
  
  public getAditivoInit(ircp_id: number): Observable<AditivoIrcpIrfe> {
    return this.http.get<AditivoIrcpIrfe>(this.baseUrl + '/aditivo-init/' + ircp_id, { headers: this.headers });
  }

  public getTiposAditivosList(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/tipos-aditivos-list', { headers: this.headers });
  }

  public aditivoCreate(obj: AditivoIrcpIrfe): Observable<AditivoIrcpIrfe> {
    return this.http.post<AditivoIrcpIrfe>(this.baseUrl + '/aditivo', obj, { headers: this.headers });
  }

  public aditivoUpdate(obj: AditivoIrcpIrfe, id: number): Observable<AditivoIrcpIrfe> {
    return this.http.put<AditivoIrcpIrfe>(this.baseUrl + '/aditivo/' + id, obj, { headers: this.headers });
  }

  public aditivoDelete(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + '/aditivo/' + id, { headers: this.headers });
  }

}
